import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PAYOR, getBrokersList } from '../../utils/utils.common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AssigTripsService } from '../../component/assigned-trips/assigntrips-service/assigntrips-service';
import { imageProcessing } from 'src/app/utils/image-processing-utils';
import { ProTipsServiceService } from 'src/app/component/nemt-pro-tips/service/pro-tips-service.service';
import * as moment from 'moment';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';



@Component({
  selector: 'app-partial-edit',
  templateUrl: './partial-edit.component.html',
  styleUrls: ['./partial-edit.component.css']
})
export class PartialEditComponent implements OnInit {
  @Input() trip: any;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() updateTripObj = new EventEmitter<any>();
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  payorList = PAYOR;
  isFileLoading = false;
  selectedFile = null;
  pdfAttachment;
  timeZone;

  constructor(
    private proTipsService: ProTipsServiceService,
    private assignTripService: AssigTripsService,
    private sharedDataService: SharedDataService,
    private fb: FormBuilder) { }

  updateTripModalForm: FormGroup;

  ngOnInit() {
    this.updateTripModalForm = this.fb.group({
      _id: [''],
      authorizationNumber:[''],
      dispatchNoteTwo: [''],
      companyNote: [''],

      preDispatchNoteTwo: [''],
      preCompanyNote: [''],

      attachment: ['']
    });

    this.getUser();
  }


  getUser() {
    this.sharedDataService.getUser().subscribe(data => {
      if (data) {
        this.timeZone = data.timeZone;

        this.updateTripModalForm.patchValue({
          ...this.trip,
          preDispatchNoteTwo: this.trip.dispatchNoteTwo,
          preCompanyNote: this.trip.companyNote,
        })
      }
    })
  }

  closeModal() {
    this.onCloseModal.emit();
  }

  brokerList(key?) {
    if (key) {
      return getBrokersList[key];
    }
    return getBrokersList;
  }

  uploadFile(selectedPDFFile) {
    this.isFileLoading = true;
    this.proTipsService
      .changeCoverImage(selectedPDFFile)
      .subscribe(data => {
        if (data) {

          this.isFileLoading = false;
          // this.pdfAttachment = data.loaction
          this.updateTripModalForm.patchValue({ attachment: data.location });
        }
      });
  }

  processCoverImageFile(pdfInput: any) {
    imageProcessing(pdfInput)
      .subscribe((result) => {
        this.fileInput.nativeElement.value = '';
        if (result && result.file && result.file.type === "application/pdf") {
          this.uploadFile(result.file);
        } else {
          // this.toastr.success("Invalid file uploaded", 'Alert');
        }
      });
  }


  onSubmit() {
    this.updateTrip(this.updateTripModalForm.value);
  }

  updateTrip(payload) {

    const date = moment().tz(this.timeZone).format("MM/DD/YYYY HH:mm a");

    if (payload.dispatchNoteTwo && payload.preDispatchNoteTwo != payload.dispatchNoteTwo) {
      payload.dispatchNoteTwo = payload.dispatchNoteTwo + ' ' + date
    }

    if (payload.companyNote && payload.preCompanyNote != payload.companyNote ) {
      payload.companyNote = payload.companyNote + ' ' + date
    }

    this.assignTripService
      .updateTrip(payload)
      .subscribe(data => {
        if (data) {
          this.updateTripObj.emit({_id: data._id, attachment: data.attachment , companyNote: data.companyNote, dispatchNoteTwo : data.dispatchNoteTwo});
          this.closeModal();
        }
      });

  }

  removeAttachment() {
    this.updateTripModalForm.patchValue({ attachment: '' });
  }

  get form() {
    return this.updateTripModalForm.controls;
  }



}
